module.exports = {
    status: "initialize",
    userTestStatus: null,
    linkDefaultTest: null,
    testReportUrl: null
    
}